export default __webpack_public_path__ + "assets/images/a26ccbd1cde4aea65ac6c6a11c536805.jpg";